import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { formatUsername } from "../../../../shared/utils/index.js";
import { shortenAddress } from "../../../../shared/utils/formatAddress.js";
import { ChevronRight } from "lucide-react";
import { CryptoPaymentMethodType } from "./CryptoPaymentMethod.js";
/**
 * Displays the selected crypto payment method with appropriate label
 * - CONNECT_WALLET: Shows wallet address/name or "Connect wallet"
 * - GLOBAL_WALLET: Shows "Global Account"
 * - TRANSFER_CRYPTO: Shows "Transfer crypto"
 * - NONE: Shows "Select payment method"
 */
export function CryptoPaymentMethodDisplay({ paymentMethod, connectedAddress, connectedName, }) {
    if (paymentMethod === CryptoPaymentMethodType.CONNECT_WALLET) {
        return (_jsxs(_Fragment, { children: [connectedAddress ? (_jsx("span", { className: "text-as-tertiary whitespace-nowrap", children: connectedName ? formatUsername(connectedName) : shortenAddress(connectedAddress) })) : (_jsx("span", { className: "whitespace-nowrap", children: "Connect wallet" })), _jsx(ChevronRight, { className: "h-4 w-4 shrink-0" })] }));
    }
    if (paymentMethod === CryptoPaymentMethodType.GLOBAL_WALLET) {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: "whitespace-nowrap", children: "Global Account" }), _jsx(ChevronRight, { className: "h-4 w-4 shrink-0" })] }));
    }
    if (paymentMethod === CryptoPaymentMethodType.TRANSFER_CRYPTO) {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: "whitespace-nowrap", children: "Transfer crypto" }), _jsx(ChevronRight, { className: "h-4 w-4 shrink-0" })] }));
    }
    // NONE or any other case
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "whitespace-nowrap", children: "Select payment method" }), _jsx(ChevronRight, { className: "h-4 w-4 shrink-0" })] }));
}
